import {useMobileAppRedirect} from "@/api/userApi";
import RightArrowIcon from "@/assets/colorable/right_arrow.svg?react";
import PhoneIcon from "@/assets/dark_gradient/phone.svg?react";
import {FC} from "react";
import {useTranslation} from "react-i18next";

const DownloadAppButton: FC = () => {
  const {t} = useTranslation("common");
  const {openAppRedirect} = useMobileAppRedirect();

  return (
    <button
      className="group border-neutral-grey-light hover:bg-neutral-white-dark/40 mb-4 flex w-fit flex-col items-center justify-center gap-3 self-center rounded-md border p-3 transition-all duration-200 md:h-16 md:flex-row"
      onClick={openAppRedirect}>
      <div className="flex items-center justify-center gap-2">
        <PhoneIcon className="h-6 w-auto shrink-0" />
        <span className="text-neutral-black text-sm leading-none font-bold">{t("areYouAnInfluencer")}</span>
      </div>
      <div className="flex items-center justify-center gap-2">
        <span className="text-medium text-primary-dark-solid group-hover:text-primary-medium-solid text-sm leading-none transition-all duration-200">
          {t("downloadApp")}
        </span>
        <RightArrowIcon className="text-primary-dark-solid group-hover:text-primary-medium-solid transition-all duration-200" />
      </div>
    </button>
  );
};

export default DownloadAppButton;
